<template>
  <div class="mt-5 row justify-content-center">
    <div class="col-sm-9 col-md-5">
      <div class="card p-4">
        <div class="card-body">
          <h1>
            Hey {{ authUser.firstName }},<br/>
          </h1>
          <p class="mb-4" style="font-size: 22px">
            You've not yet been verified as a valid user of the admin panel, make sure you have clicked verification link in the email.
            <br><br>
            If you've already clicked the verification link in the email, ask your admin to confirm your account.
          </p>

          <button class="btn btn-primary" @click="logout">
            &emsp;LOGOUT&emsp;
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { removeUser } from '../../services/auth';

  export default {
    name: 'NotVerified',
    computed: {
      ...mapState(['authUser'])
    },
    methods: {
      async logout(){
        await removeUser();
        this.$store.dispatch('setAuthUser', null);
        this.$router.replace('/login');
      }
    }
  }
</script>
